import React, {FC, ReactElement, useEffect, useRef} from 'react';
import {BrowserRouter} from "react-router-dom";
import {Grid} from "@mui/material";
import AccountantRoutes from "./accountant/AccountantRoutes";
import {userInfoStore} from "../store/UserInfo";
import {UserRole} from "../model/user/UserRole";
import ClientRoutes from "./client/ClientRoutes";
import {SnackbarKey, SnackbarProvider} from "notistack";
import {Notifier} from "./tray/Notifier";
import {notificationStore} from "../store/NotificationStore";
import WithSubscription from "../components/WithSubscription";
import {AccountantNavBar} from "./accountant/AccountantNavBar";
import {ClientNavBar} from "./client/ClientNavBar";
import {withTranslation} from "react-i18next";
import {LocalizationProvider} from "@mui/lab";
import AdapterMoment from "@mui/lab/AdapterMoment";
import {uiStateStore} from "../store/UiState";
import {BackendError} from "../model/BackendError";
import {logEvent} from "../utils/SentryUtils";
import {useAddSupportButton} from "./AddSupportPopup";

const AuthorizedApp: FC = (): ReactElement => {
    const errorHappened = useRef<SnackbarKey | undefined>(undefined);

    useAddSupportButton()

    useEffect(() => {
        window.addEventListener('unhandledrejection', (event) => {
            if (errorHappened.current) {
                notificationStore.hideNotification(errorHappened.current)
            }
            let message = "An error occurred, please reload the page";
            const reason = event.reason;
            if (reason instanceof BackendError) {
                message += ` (support id ${reason.traceId})`
                logEvent("error", reason.message, "fatal", reason)
            } else {
                logEvent("error", "Unknown error", "fatal", reason)
            }
            errorHappened.current = notificationStore.addNotification(
                    message,
                    {
                        variant: "error",
                        persist: true
                    })
        });
    }, [])

    const isAccountant = userInfoStore.userInfo.currentRole === UserRole.ACCOUNTANT;
    const isClient = userInfoStore.userInfo.currentRole === UserRole.CLIENT;

    return <>
        <LocalizationProvider dateAdapter={AdapterMoment} locale={uiStateStore.language}>
            <SnackbarProvider dense={true} maxSnack={4}>
                <Notifier/>
                <BrowserRouter>
                    <>
                        {isAccountant && <AccountantNavBar/>}
                        {isClient && <ClientNavBar/>}
                        <Grid container style={{height: "100%"}}>
                            <Grid item xs={12} style={{margin: "0.5rem 0.3rem 0.3rem 0.3rem", height: "100%"}}>
                                <WithSubscription onlyNotify={isAccountant}>
                                    {isAccountant && <AccountantRoutes/>}
                                    {isClient && <ClientRoutes/>}
                                </WithSubscription>
                            </Grid>
                        </Grid>
                    </>
                </BrowserRouter>
            </SnackbarProvider>
        </LocalizationProvider>
    </>;
}

export default withTranslation()(AuthorizedApp)